
import { mapGetters, mapActions } from 'vuex'
import dayjs from 'dayjs'

export default {
  name: 'AccountData',

  middleware: 'auth',

  data() {
    return {
      crumbs: [
        {
          label: 'account data',
          to: '/account',
        },
      ],
    }
  },

  computed: {
    ...mapGetters('transact', ['customer']),
  },

  methods: {
    ...mapActions('transact', ['setCustomer']),
    dayjs,
  },

  head() {
    return {
      title: 'Account',
    }
  },
}
